<template>
  <div class="animated fadeIn pb-8">
    <div v-if="!loaded" class="d-flex flex-column align-items-center mt-8 py-6">
      <atom-spinner :animation-duration="1000" :size="80" :color="'#7c4dff'" />
      <p class="primary--text font-weight-bold mt-4">
        در حال بارگذاری اطلاعات...
      </p>
    </div>
    <div v-else>
      <v-card class="common-card">
        <div class="d-flex flex-row">
          <h4 class="c-grey pt-2 ps-2">درخواست‌های مشاوره</h4>
        </div>
        <hr class="mb-0 pb-0" />
        <v-card flat>
          <v-container>
            <v-row class="mt-6 flex-end">
              <v-col class="text-sm-left mr-auto">
                <vue-excel-xlsx
                  v-if="requests.length"
                  :data="requests"
                  style="width: 180px; height: 43px"
                  class="darkGreen-mainBtn white--text py-2 mb-6"
                  :columns="excelFields"
                  :filename="'درخواست‌های مشاوره'"
                  sheetname="درخواست‌های مشاوره"
                >
                  <v-icon class="white--text">mdi-file-excel</v-icon> دریافت
                  اکسل
                </vue-excel-xlsx>
              </v-col>
            </v-row>

            <div class="d-flex flex-column">
              <div class="custom-table mt-3">
                <div class="custom-table-vue">
                  <v-data-table
                    responsive
                    show-empty
                    :current-page="currentPage"
                    :items-per-page="perPage"
                    :page.sync="currentPage"
                    :items="requests"
                    :headers="headers"
                    hide-default-footer
                    no-results-text="موردی برای نمایش وجود ندارد!"
                    :single-expand="singleExpand"
                    :expanded.sync="expanded"
                    show-expand
                  >
                    <template v-slot:no-data>
                      <p class="mt-3 pt-3">موردی برای نمایش وجود ندارد</p>
                    </template>
                    <template v-slot:[`item.totalPayablePrice`]="{ item }">
                      <div>
                        {{ item.totalPayablePrice.toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:empty>
                      <div
                        style="text-align: center; vertical-align: middle"
                        class="pt-0"
                      >
                        رکوردی برای نمایش وجود ندارد.
                      </div>
                    </template>

                    <template v-slot:[`item.index`]="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 + perPage * (currentPage - 1) }}
                      </div>
                    </template>

                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>

                    <template v-slot:[`item.action`]="{ item }">
                      <v-btn
                        class="primary white--text"
                        @click="showDetails(item)"
                      >
                        مشاهده جزییات
                      </v-btn>
                    </template>
                  </v-data-table>
                </div>
                <v-row class="mt-6" v-if="requests.length">
                  <v-col>
                    <div class="d-flex flex-row">
                      <span class="c-grey pt-2">نمایش در هر صفحه</span>
                      <div class="ms-3 me-3 number-box">
                        <v-select
                          outlined
                          v-model="perPage"
                          :items="perPageItems"
                          @change="currentPage = 1"
                        >
                        </v-select>
                      </div>
                    </div>
                  </v-col>
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2"> برو به صفحه </span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="whichPage"
                        type="number"
                        @change="goToPage()"
                        @click="goToPage()"
                        :items="computedIndex"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col class="text-sm-center">
                    <div>
                      <v-pagination
                        v-model="currentPage"
                        prev-icon="$ArrowLeft"
                        next-icon="$ArrowRight"
                        :length="Math.ceil(requests.length / perPage)"
                        :total-visible="5"
                        class="float-sm-end"
                      >
                      </v-pagination>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-card>

      <v-dialog v-model="detailsDialog" width="400">
        <v-card>
          <v-card-title class="white">
            <v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                  جزییات درخواست
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="detailsDialog = false"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mt-0 pt-0" />
          <div class="pa-4">
            <div class="d-flex">
              <p class="fs-medium">نام:</p>
              <p class="primary--text ms-1 font-weight-bold">
                {{ selectedRequest.name }}
              </p>
            </div>
            <div class="d-flex">
              <p class="fs-medium">نام خانوادگی:</p>
              <p class="primary--text ms-1 font-weight-bold">
                {{ selectedRequest.lastName }}
              </p>
            </div>
            <div class="d-flex">
              <p class="fs-medium">موبایل:</p>
              <p class="primary--text ms-1 font-weight-bold">
                {{ selectedRequest.mobile }}
              </p>
            </div>
            <div class="d-flex">
              <p class="fs-medium">ایمیل:</p>
              <p class="primary--text ms-1 font-weight-bold">
                {{ selectedRequest.email }}
              </p>
            </div>
            <div class="d-flex">
              <p class="fs-medium">توضیحات:</p>
              <p class="primary--text ms-1 font-weight-bold">
                {{
                  selectedRequest.description
                    ? selectedRequest.description
                    : "-"
                }}
              </p>
            </div>
          </div>
          <div class="text-left pe-3 pb-4 pt-0">
            <v-btn class="red-mainBtn" @click="detailsDialog = false">
              بستن
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>

    <!-- receipt -->
    <br />
    <router-view></router-view>
  </div>
</template>
<script>
import Axios from "axios";
import { AtomSpinner } from "epic-spinners";

export default {
  components: {
    AtomSpinner,
  },
  data() {
    return {
      requests: [],
      loaded: false,
      currentPage: 1,
      selectedRequest: {},
      perPage: 5,
      perPageItems: [5, 10, 20],
      headers: [
        { value: "index", text: "ردیف", sortable: false },
        { value: "name", text: "نام ", sortable: false },
        { value: "lastName", text: "نام خانوادگی", sortable: false },
        { value: "mobile", text: "شماره موبایل", sortable: false },
        { value: "email", text: "ایمیل", sortable: false },
        { value: "action", text: "عملیات", sortable: false },
      ],
      excelFields: [
        { field: "name", label: "نام" },
        { field: "lastName", label: "نام خانوادگی" },
        { field: "mobile", label: "شماره موبایل" },
        { field: "email", label: "ایمیل" },
      ],
      whichPage: 1,
      detailsDialog: false,
    };
  },
  methods: {
    showDetails(item) {
      this.selectedRequest = item;
      this.detailsDialog = true;
    },
    goToPage() {
      this.currentPage = Number(this.whichPage);
    },
    getList() {
      this.loaded = false;
      Axios.post(
        this.baseUrl + "/satrapp/consultations/list",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.requests = res.data;
            this.toast(res.data.message, "success");
            this.loaded = true;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loaded = true;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loaded = true;
        });
    },

    closeDetails() {
      this.detail = false;
      this.details = [];
      this.income = {};
    },
  },
  mounted() {
    this.getList();
  },
  computed: {
    computedIndex() {
      let arr = [];
      let computedLength = this.requests.length;
      let arrLength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrLength; i++) {
        arr.push(i);
      }
      return arr;
    },
  },
};
</script>
<style lang="scss">
.customSelect2 {
  .v-input__slot {
    width: 120px !important;
  }
  .v-select__selection--comma {
    font-size: 14px !important;
  }
}
.custom-input {
  .v-input__slot {
    width: 210px !important;
  }
  .v-input__control {
    flex-direction: row !important;
  }
  .v-text-field .v-input__control,
  .v-text-field fieldset {
    min-height: 45px !important;
    border-color: #7c4dff !important;
  }
  .v-label:not(.v-label--active) {
    transform: translateY(2px);
  }
}
.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.custom-input {
  .v-input__slot {
    width: 210px !important;
  }
  .v-input__control {
    flex-direction: row !important;
  }
  .v-text-field .v-input__control,
  .v-text-field fieldset {
    min-height: 45px !important;
    border-color: #7c4dff !important;
  }
  .v-label:not(.v-label--active) {
    transform: translateY(2px);
  }
  .theme--light.v-data-table .v-data-table-header th.sortable:hover {
    color: white !important;
  }
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th {
    color: white !important;
  }
  .v-data-table
    > .v-data-table__wrapper
    tbody
    tr.v-data-table__expanded__content {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
  .theme--light.v-card > .v-card__subtitle,
  .theme--light.v-card > .v-card__text {
    color: black !important;
  }
  .theme--light.v-data-table {
    background-color: #fff;
    color: black !important;
  }
  table thead {
    color: black !important;
  }
  .custom-table-vue .v-data-table-header tr th {
    text-align: center !important;
    font-size: 15px !important;
    color: black !important;
    height: 50px !important;
  }
}
</style>
